var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNavigator(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "328px",
    height: "193px",
    viewBox: "346 487 328 193",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "client-copy",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(346.000000, 487.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-5",
    fill: "#050505",
    x: 0,
    y: 0,
    width: 328,
    height: 193,
    rx: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,25.5441176 L328,25.5441176 L328,185.007812 C328,189.421775 324.428194,193 319.993845,193 L8.00615545,193 C3.58447789,193 0,189.424975 0,185.007812 L0,25.5441176 Z",
    id: "Rectangle-6",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("g", {
    id: "dots",
    transform: "translate(8.519481, 8.514706)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "red",
    fill: "#c62828",
    cx: 5.67965368,
    cy: 5.67647059,
    rx: 5.67965368,
    ry: 5.67647059
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "yellow",
    fill: "#ffb300",
    cx: 22.7186147,
    cy: 5.67647059,
    rx: 5.67965368,
    ry: 5.67647059
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "green",
    fill: "#2e7d32",
    cx: 39.7575758,
    cy: 5.67647059,
    rx: 5.67965368,
    ry: 5.67647059
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigator);
export default __webpack_public_path__ + "static/media/navigator.39da5b63d958fe823cd9926c38698fc3.svg";
export { ForwardRef as ReactComponent };